/* @flow */
import liferay from '../../services/api';

import type { Action, AsyncAction } from '../../types';

const onFailure = (error: Object) => console.warn(error);

const fetchSmartlist = (id: number): AsyncAction => {
  return {
    type: 'FETCH_SMARTLIST_REQUEST',
    payload: id,
    promise: liferay.smartlists.get(id),
    meta: { onFailure },
  };
};

const fetchSmartlistItems = (id: number): AsyncAction => {
  return {
    type: 'FETCH_SMARTLIST_ITEMS_REQUEST',
    payload: id,
    promise: liferay.smartlists.items.find(id),
    meta: { onFailure },
  };
};

const smartlistSetPageScroll = (pageScroll: number): Action => {
  return {
    type: 'SMARTLIST_SCROLL_PAGE',
    payload: pageScroll,
  };
};

const smartlistExpandItem = (itemId: number, isExpanded: boolean): Action => {
  return {
    type: 'SMARTLIST_EXPAND_ITEM',
    payload: {
      itemId,
      isExpanded,
    },
  };
};

const smartlistToggleSelectItems = (itemIds: number[]): Action => {
  return {
    type: 'SMARTLIST_TOGGLE_SELECT_ITEMS',
    payload: itemIds,
  };
};

const smartlistToggleExpandSelectedItems = (): Action => {
  return {
    type: 'SMARTLIST_TOGGLE_EXPAND_SELECTED_ITEMS',
  };
};

export default {
  fetchSmartlist,
  fetchSmartlistItems,
  smartlistSetPageScroll,
  smartlistExpandItem,
  smartlistToggleSelectItems,
  smartlistToggleExpandSelectedItems,
};
